import React from 'react';
import PropTypes from 'prop-types';

import {frefFromRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEStdModalController from '../../modals/oe-std-modal-controller';
import {OECustomCheckbox} from '../../elements/controls/oe-checkbox';
import {OEButtonControl} from '../../elements/controls/oe-controls';
import {OEBlurModalBackdropLayer} from '../oe-blur-layer';
import LocalStorage from '../../../lib/tools/local-storage';
import OETextView from '../text-view/oe-text-view';
import OECoreHideLayer from '../oe-core-hide-layer';
import {OEWelcomeViewProps, OEWelcomeViewConfigFactory} from './oe-welcome-view-model';

export class OEDisclaimerView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            disclaimerWasAccepted:  LocalStorage.getItem('disclaimerWasAccepted') === 'true',
            strings: {
                acceptDisclaimer:   'I accept the diclaimer',
                closeBtn:           'Close'
            },
            textViewStyle:          {},
            willOpenAtStartUp:      false
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onContentSizeChanged = this.onContentSizeChanged.bind(this);

        this.onRef = this.onRef.bind(this);
        this.onTextViewRef = this.onTextViewRef.bind(this);

        this.onDisclaimerClicked = this.onDisclaimerClicked.bind(this);
        this.onCloseBtnPressed = this.onCloseBtnPressed.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.config.src !== this.props.config.src || nextProps.config.srcId !== this.props.config.srcId)    {
            this.updateSrc(nextProps);
        }

        if(this.timeout && this.shouldOpenAtStartUp() != this.shouldOpenAtStartUp(nextProps))   {
            this.setState({willOpenAtStartUp: this.shouldOpenAtStartUp(nextProps)});
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);

        this.setState({willOpenAtStartUp: this.shouldOpenAtStartUp()});
        this.timeout = setTimeout(this.onTimeout.bind(this), 500);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);

        if(this.timeout)    {
            clearTimeout(this.timeout);
            this.timeout = 0;
        }
    }

    shouldOpenAtStartUp(props)   {
        return !this.state.disclaimerWasAccepted;
    }

    onTimeout() {
        this.timeout = 0;

        if(!this.ref)   {
            this.timeoutCall = true;
            return;
        }

        if(this.oe.isReady() && this.shouldOpenAtStartUp())   {
            this.ref.setOpen(true);
        }
        this.setState({willOpenAtStartUp: false});

        this.timeoutCall = false;
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        this.setState({strings: {
            acceptDisclaimer:   si.getLocalizedStringEnc('disclaimer_accept'),
            closeBtn:           si.getLocalizedStringEnc('disclaimer_close')
        }});

        this.updateSrc();
    }

    updateSrc(props) {
        if(!this.oe.isReady())  return;
        props = props || this.props;

        let src;
        if(props.config.srcId) {
            src = this.oe.sharedInterface.getLocalizedStringEnc(props.config.srcId);
            src = 'app/oe/' + this.oe.Module.filePackagePathURL + src;
        } else {
            src = props.config.src;
        }

        this.setState({src: src});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    updateTextViewStyle()  {
        if(!this.textViewRef)   return;
        let height = `calc(${this.textViewRef.contentSize.h}px)`;
        this.setState({textViewStyle: {height: height}});
    }

    onContentSizeChanged()  {
        this.updateTextViewStyle();
    }

    onRef(ref)  {
        this.ref = ref;
        if(this.props.fref) this.props.fref(ref);
        if(ref && this.timeoutCall) this.onTimeout();
    }

    onTextViewRef(ref)  {
        if(this.textViewRef === ref) return;
        this.textViewRef = ref;
        this.updateTextViewStyle();
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OEStdModalController 
                    moduleId={this.props.moduleId}
                    className="clear-backdrop center fit-content disclaimer-view"
                    noHeader={true}
                    isOpen={this.props.isOpen}
                    keyboard={this.props.devFeatures}
                    hasCloseBtn={false}
                    onOpenStateChanged={this.props.onOpenStateChanged}
                    onToggle={this.props.onToggle}
                    ref={this.onRef}
                >

                    <OETextView
                        moduleId={this.props.moduleId}
                        style={this.state.textViewStyle}
                        className="diclaimer"
                        src={this.state.src}
                        onContentSizeChanged={this.onContentSizeChanged}
                        ref={this.onTextViewRef}
                    />

                    <div className="bottom">
                        <div className="check-box-container">
                            <OECustomCheckbox className="disclaimer-accept-cb" checked={this.state.disclaimerWasAccepted} onPressed={this.onDisclaimerClicked}/>
                            <span>{this.state.strings.acceptDisclaimer}</span>
                        </div>
                        <OEButtonControl className="close-btn" disabled={!this.state.disclaimerWasAccepted} onPressed={this.onCloseBtnPressed}>{this.state.strings.closeBtn}</OEButtonControl>
                    </div>

                    <OEBlurModalBackdropLayer/>

                    <OECoreHideLayer moduleId={this.props.moduleId} hideFlags={this.props.config.coreHideFlags}/>

                </OEStdModalController>

                <OECoreHideLayer moduleId={this.props.moduleId} hideFlags={this.state.willOpenAtStartUp ? this.props.config.coreHideFlags : 0}/>

            </React.Fragment>
        );
    }

    onDisclaimerClicked()    {
        var newState = !this.state.disclaimerWasAccepted;
        LocalStorage.setItem('disclaimerWasAccepted', newState ? 'true' : 'false');
        this.setState({disclaimerWasAccepted: newState});
    }

    onCloseBtnPressed() {
        if(this.ref)    this.ref.setOpen(false);
        if(this.props.config.showStartView && LocalStorage.getItem('dontShowStartViewAtStartUp') !== 'true' && this.props.appComponent && this.props.appComponent.uiLayer && this.props.appComponent.uiLayer.startView) {
            this.props.appComponent.uiLayer.startView.setOpen(true);
        }
    }
}

OEDisclaimerView.defaultProps = {
    moduleId:               '',
    config:                 OEWelcomeViewConfigFactory.buildStdConfig(),
    devFeatures:            false
};

OEDisclaimerView.propTypes = {
    moduleId:               PropTypes.string,
    isOpen:                 PropTypes.bool,
    onOpenStateChanged:     PropTypes.func,
    onToggle:               PropTypes.func,
    fref:                   PropTypes.func,
    config:                 OEWelcomeViewProps.config,
    devFeatures:            PropTypes.bool
};

export default frefFromRef(OEDisclaimerView);